import { render, staticRenderFns } from "./shoporders.vue?vue&type=template&id=a210f5aa&scoped=true"
import script from "./shoporders.vue?vue&type=script&lang=js"
export * from "./shoporders.vue?vue&type=script&lang=js"
import style0 from "./shoporders.vue?vue&type=style&index=0&id=a210f5aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210f5aa",
  null
  
)

export default component.exports